module.exports = __webpack_public_path__ + "static/img/A64.91c6a71b.jpg";